import { Injectable } from '@angular/core';

export interface OriginalJson {
  COMPOSICION: Array<{
    NombreUE: string;
    DescripcionNota: string;
    "Nombre Sustancia": string;
    Concentracion: number;
  }>;
  usosAgentes: string[];
  DATOSPRODUCTO: {
    Fecha_LimiteVenta: string;
    Fecha_Cancelacion: string;
    Nombre: string;
    Condicionamiento: string;
    Titular: string;
    IdProducto: number;
    Formulado: string;
    Fecha_Caducidad: string;
    Fabricante: string;
    Num_Registro: string;
    Fabrica: string;
    Fecha_Registro: string;
    Estado: string;
  };
  usosCultivos: string[];
  OTRASDENOMINACIONES: Array<{
    Nombre_Origen: string;
  }>;
}

interface TransformedJson {
  datosProducto: {
    fabricante: string;
    fabrica: string;
    nombre: string;
    fechaCancelacion: string;
    estado: string;
    formulado: string;
    titular: string;
    fechaLimiteVenta: string;
    fechaRegistro: string;
    numRegistro: string;
    fechaCaducidad: string;
    condicionamiento: string;
    idProducto: number;
  };
  usosCultivos: string[];
  composicion: Array<{
    nombreSustancia: string;
    concentracion: number;
    descripcionNota: string;
    nombreUe: string;
  }>;
}

@Injectable({
  providedIn: 'root',
})
export class ProductofitoTransformerService {
  constructor() {}

  transformJson(originalJson: OriginalJson): TransformedJson {
    const transformedJson: TransformedJson = {
      datosProducto: {
        fabricante: originalJson.DATOSPRODUCTO.Fabricante,
        fabrica: originalJson.DATOSPRODUCTO.Fabrica,
        nombre: originalJson.DATOSPRODUCTO.Nombre,
        fechaCancelacion: originalJson.DATOSPRODUCTO.Fecha_Cancelacion,
        estado: originalJson.DATOSPRODUCTO.Estado,
        formulado: originalJson.DATOSPRODUCTO.Formulado,
        titular: originalJson.DATOSPRODUCTO.Titular,
        fechaLimiteVenta: originalJson.DATOSPRODUCTO.Fecha_LimiteVenta,
        fechaRegistro: originalJson.DATOSPRODUCTO.Fecha_Registro,
        numRegistro: originalJson.DATOSPRODUCTO.Num_Registro,
        fechaCaducidad: originalJson.DATOSPRODUCTO.Fecha_Caducidad,
        condicionamiento: originalJson.DATOSPRODUCTO.Condicionamiento,
        idProducto: originalJson.DATOSPRODUCTO.IdProducto,
      },
      usosCultivos: Array.from(new Set(originalJson.usosCultivos)), // Eliminar duplicados
      composicion: originalJson.COMPOSICION.map((comp) => ({
        nombreSustancia: comp["Nombre Sustancia"],
        concentracion: comp.Concentracion,
        descripcionNota: comp.DescripcionNota,
        nombreUe: comp.NombreUE,
      })),
    };

    return transformedJson;
  }
}



